import { type CategoriaDTO } from '@framework/api-client/api/inquiries/schemas/categoriaDTO.ts';
import {
  getFrontCategorie,
  getGetFrontCategorieQueryOptions,
} from '@framework/api-client/api/inquiries-compile/categorie-controller/categorie-controller.ts';
import { createAsyncSelectChipValue } from '@framework/form/inputs/AsyncSelectChipValue.tsx';
import {
  AsyncSelectInput,
  type IBaseAsyncSelectInputProps,
} from '@framework/form/inputs/AsyncSelectInput.tsx';

export interface IFrontCategoryAsyncSelectInputProps
  extends IBaseAsyncSelectInputProps {}

export function FrontCategoryAsyncSelectInput(
  props: IFrontCategoryAsyncSelectInputProps,
) {
  return (
    <AsyncSelectInput
      queryFn={getFrontCategorie}
      initialParams={{ ordinamenti: ['etichetta'] }}
      queryOptions={getGetFrontCategorieQueryOptions}
      searchByField="text"
      asOption={(category: CategoriaDTO) => ({
        value: category.id!,
        label: category.etichetta!,
      })}
      {...props}
    />
  );
}

/**
 * `renderValue` per il chip FilterBar: risolve gli id categoria nelle etichette.
 * La lista (ordinata per etichetta) è caricata interamente → nessuna ricerca per
 * valore necessaria.
 */
export const frontCategoryChipValue = createAsyncSelectChipValue({
  queryFn: getFrontCategorie,
  queryOptions: getGetFrontCategorieQueryOptions,
  initialParams: { ordinamenti: ['etichetta'] },
  asOption: (category: CategoriaDTO) => ({
    value: category.id ?? '<unknown>',
    label: category.etichetta ?? '',
  }),
});
